import { Slot } from '../types';
import Lottie from 'lottie-react';

import noDataAnimation from '@/assets/animation/no_data.json';
import blueDogLoader from '@/assets/animation/blue_dog_loader.json';
import progressAnimation from '@/assets/animation/save_loader.json';
import { useGetAvailabilities } from '../api/getAvailability';
import './Slots.scss';
import { Business } from '@/features/business';
import Utils from '@/utils/util';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
export type SlotsProps = {
  slots: Slot[] | undefined;
  startTime: string | null;
  onSelectSlot: (item: any) => void;
  title: string;
  businessData?: Business;
  showAllSlots?: boolean;
};
export const Slots = ({
  slots,
  startTime,
  onSelectSlot,
  title,
  businessData,
  showAllSlots = false,
}: SlotsProps) => {
  const useGetAvailabilitiesMutation = useGetAvailabilities();
  const [selectedSlot, setSelectedSlot] = useState('');
  const { t, i18n } = useTranslation();
  const getSlotLastTime = (slots: any) => {
    const amLength = slots?.length;
    if (amLength && amLength >= 1) {
      return slots[amLength - 1]?.label;
    } else {
      return slots[0];
    }
  };
  useEffect(() => {
    setSelectedSlot(startTime ? startTime : '');
  }, [startTime]);
  const nonBusySlots = slots?.filter((item) => !item.isBusy);
  const isAllSlotsVisible = showAllSlots
    ? slots && slots?.length > 0
      ? true
      : false
    : nonBusySlots && nonBusySlots?.length > 0
    ? true
    : false;
  return (
    <>
      <div className="title-and-add-btn-row">
        <div>
          <div className="slots-desc">
            {title} {t('slots')} -{' '}
            {slots && slots.length > 0 ? `${slots[0].label} to ${getSlotLastTime(slots)}` : '00:00'}{' '}
            <span className="text-sm text-gray-500">{Utils.getTzAbbr(businessData?.timezone)}</span>
          </div>
        </div>
      </div>

      {useGetAvailabilitiesMutation.isLoading ? (
        <div className="loader-slots flex items-center justify-center">
          <Lottie animationData={blueDogLoader} />
        </div>
      ) : isAllSlotsVisible ? (
        <div className="slots">
          {slots &&
            slots?.map((item, index) => {
              return (
                (showAllSlots || !item.isBusy) && (
                  <div
                    key={index}
                    className={`slot-item ${item.isBusy ? 'busy' : ''} ${
                      selectedSlot == item.start ? 'selected' : ''
                    }`}
                    onClick={() => {
                      onSelectSlot(item);
                    }}
                  >
                    <div className="pet-detail-info">
                      <div className="pet-detail-desc">{item?.label}</div>
                    </div>
                  </div>
                )
              );
            })}
        </div>
      ) : (
        <>
          <div className="no-data-selected-pet-row">
            {/* <div>
              <Lottie className="h-60 w-60" animationData={noDataAnimation} />
            </div> */}
            <div className="my-3 text-center mobile-fixed-font">{t('Slots are not available')}</div>
          </div>
        </>
      )}
    </>
  );
};
